module.exports = __webpack_public_path__ + "img/tile-inf3.a35ab409.jpg";